module.exports = __webpack_public_path__ + "89f17d6c797d3a4d4a75289678775d2c.svg";